export function b64toBlob(b64Data, contentType = 'application/octet-stream', sliceSize = 512) {
    const byteArrays = [];
    const byteCharacters = atob(b64Data);

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i += 1) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        byteArrays.push(new Uint8Array(byteNumbers));
    }

    return new Blob(byteArrays, { type: contentType });
}

export function arrayBufferToBase64(buffer) {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    for (let i = 0; i < bytes.byteLength; i += 1) {
        binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
}

export function appendBuffer(buffer1, buffer2) {
    const tmp = new Uint8Array(buffer1.length + buffer2.length);
    tmp.set(new Uint8Array(buffer1), 0);
    tmp.set(new Uint8Array(buffer2), buffer1.length);

    const array = uint8ArrayToArray(tmp);
    return array;
}

function uint8ArrayToArray(uint8Array) {
    const array = [];

    for (let i = 0; i < uint8Array.byteLength; i += 1) {
        array[i] = uint8Array[i];
    }

    return array;
}

export function removeExtDuplications(analytics) {
    const paresdAnalytics = JSON.parse(JSON.stringify(analytics));
    const filteredValues = [];
    paresdAnalytics.forEach(({ values }) => {
        for (let i = 0; i < values.length; i += 1) {
            const { value } = values[i];
            // eslint-disable-next-line no-plusplus
            if (filteredValues.includes(value)) values.splice(i--, 1);
            else filteredValues.push(value);
        }
    });
    return paresdAnalytics;
}

export function sortAlphabetically(object, key) {
    return object.sort((a, b) => a[key].localeCompare(b[key]));
}

/* eslint-disable prettier/prettier */
const iso_8859_15_table = {
    338: 188,
    339: 189,
    352: 166,
    353: 168,
    376: 190,
    381: 180,
    382: 184,
    8364: 164
};

/* eslint-disable prettier/prettier */
export function iso_8859_15_to_uint8array(iso_8859_15_str) {
    let buf = new ArrayBuffer(iso_8859_15_str.length);
    let bufView = new Uint8Array(buf);
    for (let i = 0, strLen = iso_8859_15_str.length; i < strLen; i++) {
        let octet = iso_8859_15_str.charCodeAt(i);
        if (iso_8859_15_table.hasOwnProperty(octet)) octet = iso_8859_15_table[octet];
        bufView[i] = octet;
        if (octet < 0 || 255 < octet) console.error('invalid data error');
    }
    return bufView;
}
